import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { hexColorSchema } from '@zaoblako/shared/modules/serde/schemas/hex-color.schema';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** Master milestone create/update request body */
export interface MasterMilestoneFormInterface {
  /** Milestone display name */
  name: string;
  /** Milestone color */
  color?: string | null;
}

/** Master milestone create/update request body - DTO schema */
export const MasterMilestoneFormDto = SerdeDtoClass.create<MasterMilestoneFormInterface>(CatalogDtosKeysEnum.MASTER_MILESTONE_FORM_DTO, {
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  color: {
    optional: true,
    label: 'Цвет',
    serializer: hexColorSchema,
  },
});
